/**
 * Persisted "how did you enter the app" choice made at the first-run sign-in
 * gateway (WelcomePage): either play as a guest (offline, no sync) or use an
 * account. Read once at boot (App.jsx) to decide whether to show the gateway.
 *
 * Only meaningful when SYNC_ENABLED is true — the offline-only build never shows
 * the gateway, so this key simply stays null and is never consulted.
 *
 * Goes through the storage abstraction (never localStorage directly), so it
 * follows the app onto Capacitor like everything else.
 */

import storage from './storage.js';
import { STORAGE_KEYS } from '../data/constants.js';

export const ENTRY_GUEST = 'guest';
export const ENTRY_ACCOUNT = 'account';

/** @returns {Promise<'guest'|'account'|null>} */
export async function getEntryChoice() {
  const value = await storage.getItem(STORAGE_KEYS.ENTRY_CHOICE);
  return value === ENTRY_GUEST || value === ENTRY_ACCOUNT ? value : null;
}

/** @param {'guest'|'account'} choice */
export async function setEntryChoice(choice) {
  if (choice !== ENTRY_GUEST && choice !== ENTRY_ACCOUNT) return;
  await storage.setItem(STORAGE_KEYS.ENTRY_CHOICE, choice);
}

/** Forget the choice (e.g. on sign-out you may want the gateway again). */
export async function clearEntryChoice() {
  await storage.removeItem(STORAGE_KEYS.ENTRY_CHOICE);
}

export default { getEntryChoice, setEntryChoice, clearEntryChoice, ENTRY_GUEST, ENTRY_ACCOUNT };
